import React, { useCallback, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import Municipality from './Municipality';
import PropertySection from './PropertySection';
import InfiniteScroll from 'react-infinite-scroll-component';
import RpadResults from './RpadResults';
import { useOrderEntry } from '../../OrderEntryContext';
import { Property, MatchedProperty, SelectedCity } from '../../types';
import debounce from 'lodash.debounce';
import { GarbageIcon } from '../../../../components/icons';
import { DownCarotIcon } from '../../ui/icons';
import { FiTrash2 } from 'react-icons/fi';
import { Match } from './types';
import { trimEnd } from '../../../../components/utilities/functions';

const ErrorText = styled.div`
  font-size: 13px;
  color: #c50e29;
`;

 

interface Props {
  index: number;
  setDeleteConfirmation: any;
  property: any;
  setEditIndex: any;
  findMatches: (e: any, p: any) => void;
  callRpadValidation: (searchTerm: string, property: Property, resultCount: number) => void;
  matches: Match;
  searchText: string;
  setPropertyInfo: (p: any, index: number) => void;
  addSellersToNames: any;
  setMatches: React.Dispatch<React.SetStateAction<Match>>;
  isLoading: boolean;
}
const PropertyDisplay = (props: Props) => {
  const { properties, changePropertyInfo, propertyErrors, validateProperty } = useOrderEntry();
  const [resultCount, setResultCount] = useState(15);
  //   const validateProperty = () => {
  //     const property = props.property;
  //     const errors: SubmitionPropertyError = {};
  //     if (!property.address) {
  //       errors.address = 'Missing Street';
  //     }
  //     if (
  //       (!property.undeterminedLocality && !property.selectedCity?.municipalityId) ||
  //       (property.undeterminedLocality && !property.undeterminedLocality)
  //     ) {
  //       errors.municipality = 'Missing Municipality';
  //     }
  //     setErrors(errors);
  //     return Object.keys(errors).length === 0 ? null : errors;
  //   };
  const submitEdit = () => {
    const err = validateProperty();
    if (!err[props.index]) {
      props.setEditIndex(-1);
    }
  };
  return (
    <div style={{ position: 'relative', marginTop: 24 }}>
      <Municipality
        property={props.property}
        changePropertyInfo={changePropertyInfo}
        index={props.index}
        setPropertyInfo={props.setPropertyInfo}
      />
      {props.index < properties.length - 1 ? (
        <span style={{ position: 'absolute', right: 20, top: 0, cursor: 'pointer' }}>
          <DownCarotIcon style={{ transform: 'rotate(180deg)' }} onClick={submitEdit} />
        </span>
      ) : properties.length - 1 ? (
        <FiTrash2
          style={{ position: 'absolute', right: 20, top: 0, cursor: 'pointer' }}
          onClick={() => props.setDeleteConfirmation(props.index)}
        />
      ) : (
        <div />
      )}
      {propertyErrors[props.index]?.municipality && (
        <ErrorText>{propertyErrors[props.index].municipality}</ErrorText>
      )}
      <div style={{ position: 'relative' }}>
        <PropertySection
          changePropertyInfo={changePropertyInfo}
          index={props.index}
          property={props.property}
          findMatches={(e: any) => {
            props.findMatches(e, props.property);
            setResultCount(15);
          }}
          error={
            propertyErrors[props.index]?.address && (
              <ErrorText>{propertyErrors[props.index].address}</ErrorText>
            )
          }
          isLoading={props.isLoading}
        />
        {props.matches.results.length > 0 && (
          <div
            style={{
              position: 'absolute',
              zIndex: 10000,
              top: 76,
              width: 950,
              boxShadow: '0px 0px 16px 0px #eae8e5',
              maxHeight: 350,
              overflow: 'auto',
            }}
            id="infiniteDiv"
          >
            <InfiniteScroll
              dataLength={props.matches.results.length} //This is important field to render the next data
              next={() => {
                const newResultCount = resultCount + 15;
                props.callRpadValidation(props.searchText, props.property, newResultCount);
                setResultCount(newResultCount);
              }}
              hasMore={props.matches.results.length !== props.matches.totalCount}
              loader={<div style={{ padding: 16, backgroundColor: '#fff' }}>Loading...</div>}
              scrollThreshold={0.2}
              scrollableTarget="infiniteDiv"
            >
              <RpadResults
                matches={props.matches.results}
                searchText={props.searchText}
                handleClick={(m: MatchedProperty, s: SelectedCity) => {
                  const property: Property = {
                    address: m.address,
                    block: s.stateCode === 'NJ'?trimEnd(m.property.block, "."):(m.property.block) ,
                    countyOnly: false,
                    district: m.muniTypes[2]?.district ?? m.muniTypes[1]?.district,
                    includeMunicipalSearches: true,
                    isDuplicate: false,
                    isValidated: true,
                    lot: s.stateCode === 'NJ'? trimEnd(m.property.lot, "."): m.property.lot,
                    municipalityId: m.muniTypes[1].id,
                    subMunicipalityId: m.muniTypes[2]?.id,
                    owners: m.owners,
                    printKey: m.printKey,
                    rpadPropertyId: m.id,
                    section: m.property.section,
                    qualifier: m.property.qualifier,
                    selectedCity: s.municipalityId
                      ? s
                      : {
                          county: m.muniTypes[0]?.name,
                          countyId: m.muniTypes[0]?.id,
                          municipality: m.muniTypes[1]?.name,
                          municipalityId: m.muniTypes[1]?.id,
                          municipalityType: m.muniTypes[1]?.type,
                          subMunicipality: m.muniTypes[2]?.name,
                          subMunicipalityType: m.muniTypes[2]?.type,
                          subMunicipalityId: m.muniTypes[2]?.id,
                          swisCode: m.muniTypes[2]?.swisCode || m.muniTypes[1]?.swisCode,
                          stateCode: m.muniTypes[0]?.stateCode,
                          stateName: m.muniTypes[0]?.state,
                        },
                    zip: m.location.zip,
                    addressLine2: m.aptNo,
                    validationNote: '',
                    validationFiles: [],
                    selectedCounty: null,
                    hamletId: s?.hamletId || undefined,
                    buildingCode: m.property.propertyClass,
                  };
                  props.setPropertyInfo(property, props.index);
                  props.addSellersToNames(m.owners);
                  props.setMatches({ totalCount: null, results: [] });
                }}
                propertyIndex={props.index}
              />
            </InfiniteScroll>
          </div>
        )}
      </div>
    </div>
  );
};
export default PropertyDisplay;
